<template>
  <div class="peer-assmnt__grading_criteria-item">
    <div class="peer-assmnt__grading_criteria-item_title">
      {{ grading_criterion.name }}
    </div>

    <div class="peer-assmnt__grading_criteria-item_info">
      <div class="grader-panel-breakdown__content">
        <div class="grader-panel-breakdown__content_description">
          <read-more
            v-if="grading_criterion.description"
            :text="grading_criterion.description"
          />
        </div>

        <div class="grader-panel-breakdown__content_points">
          <div class="grader-panel-breakdown__content_value">
            <span
              v-if="!grading_criterion.is_numerical_assessment_required"
              class="grader-panel-breakdown__value_edit_points"
            >N/A</span>

            <div
              v-else-if="isNaN(parseInt(value)) || (editing == 'value') || errors.has('value')"
              class="grader-panel-breakdown__content_input"
            >
              <input
                class="form-control"
                name="value"
                type="text"
                maxlength='5'
                size='5'
                v-focus="editing == 'value'"
                v-model.number="value"
                :validate="numericValidator"
                @click="editing = 'value'"
                @blur="save"
              />

              <input
                name='points'
                type='hidden'
                v-model.number="grading_criterion.points"
              />

              <div class="grader-panel-breakdown__content_input-label">
                / {{ grading_criterion.points }}
              </div>

              <span v-if="errors.has('value')" class="caption.error_message">
                {{ errors.first('value') }}
              </span>
            </div>

            <a
              v-else
              class="grader-panel-breakdown__value_edit"
              @click="editing = 'value'"
            >
              <span class="grader-panel-breakdown__value_edit_points">
                {{ value }} / {{ grading_criterion.points }}
              </span>

              <span class="grader-panel-breakdown__value_edit_btn">
                <i class="kf kf-pencil" />
              </span>
            </a>
          </div>
        </div>
      </div>

      <div class="peer-assmnt__criteria_leave-feedback">
        <div
          v-if="!notes.length || editing == 'notes'"
          class="grade-feedback-editor__title"
        >
          Leave Feedback
          <span
            v-if="writtenFeedbackRequired"
            class="valgn-sup txt-lte"
          >*</span>

          <input
            name='notes'
            type='hidden'
            v-model='notes'
            :validate="writtenFeedbackValidator"
          />

          <span
            v-if="errors.has('notes')"
            class="caption error_message mb1"
          >
            {{ errors.first('notes') }}
          </span>

          <div class="grade-feedback-editor__edit">
            <quill
              v-model="notes"
              toolbarType="minimal"
              placeholder="Add your notes..."
              required=true
              @blur="save"
              @focus="editing = 'notes'"
              @change="changeNotes"
            ></quill>

            <span class="quill-required-error hide">
              {{ I18n.t('required_field') }}
            </span>
          </div>
        </div>

        <template v-else>
          <div class="grade-feedback-editor__title">
            Feedback
          </div>

          <a
            class="grade-feedback-editor__preview"
            @click="editing = 'notes'"
          >
            <span class="grade-feedback-editor__preview_copy" v-html="notes" />

            <span class="grade-feedback-editor__preview_edit-btn">
              <i class="kf kf-pencil" />
            </span>
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Quill from 'libs/components/quill'

export default {
  props: ['grading_criterion'],

  components: {
    Quill
  },

  data() {
    return {
      old_value: null,
      old_notes: null,
      editing: null
    };
  },

  computed: {
    numericValidator() {
      return {
        rules: {
          required: true,
          numeric: true,
          dynamic_max_value: 'points'
        }
      }
    },

    writtenFeedbackValidator() {
      return this.writtenFeedbackRequired ? { rules: { required: true } } : ''
    },

    writtenFeedbackRequired() {
      return this.grading_criterion.is_written_feedback_required
    },

    value: {
      get() {
        return this.grading_criterion.grade_entry.value;
      },

      set(value) {
        this.grading_criterion.grade_entry.value = value;
      }
    },

    notes: {
      get() {
        return this.grading_criterion.grade_entry.notes || '';
      },

      set(value) {
        this.grading_criterion.grade_entry.notes = value;
      }
    }
  },

  watch: {
    editing(value) {
      if (value !== null) {
        this.old_value = this.value;
        this.old_notes = this.notes;
      }
    }
  },

  methods: {
    changeNotes({ html }) {
      this.notes = html
    },

    save() {
      console.log('saving criterion.vue')

      if (this.editing === 'value') {
        this.old_value = this.value;
      } else if (this.editing === 'notes') {
        this.old_notes = this.notes;
      }

      this.$validator.validateAll();
      this.editing = null;
    },

    undo() {
      //
      // only works if blur callback is disabled
      //

      if (this.editing === 'value') {
        this.value = this.old_value;
      } else if (this.editing === 'notes') {
        this.notes = this.old_notes;
      }

      this.editing = null;
    }
  },
};
</script>
